import { assign, set } from 'lodash'
import { apiV3TransferRequestsPath } from 'lib/urls'
import { errorMessage, infoMessage, successMessage } from 'lib/flash-message'
import { createCashFund } from './requests'

export const CLEAR_ATTRIBUTES = 'CLEAR_ATTRIBUTES'
export const clearAttributes = (data) => {
  return {
    type: CLEAR_ATTRIBUTES,
    data,
  }
}

export const HIDE_CASH_FUND_WIZARD = 'HIDE_CASH_FUND_WIZARD'
export const hideWizard = () => {
  return {
    type: HIDE_CASH_FUND_WIZARD,
  }
}

export const POPULATE_FAKE_DATA = 'POPULATE_FAKE_DATA'
export const populateFakeData = () => {
  return {
    type: POPULATE_FAKE_DATA,
  }
}

export const SAVE = 'SAVE'
export const save = (onSuccess, stripe) => {
  return (dispatch, getState) => {
    const state = getState()
    const data = state.cashFund || state

    dispatch({ type: SAVE_START })

    // Create the bank account in Stripe
    if (!data.registryOwnerHasBankAccount) {
      stripe
        .createToken('bank_account', {
          country: 'US',
          currency: 'usd',
          routing_number: data.routingNumber,
          account_number: data.accountNumber,
          account_holder_name: `${data.firstName} ${data.lastName}`,
          account_holder_type: 'individual',
        })
        .then(({ error, token }) => {
          if (error) {
            if (/.*account number.*/i.test(error.message)) {
              dispatch(
                updateErrors(
                  set({}, 'bankAccount.accountNumber', error.message)
                )
              )
            } else if (/.*routing number.*/i.test(error.message)) {
              dispatch(
                updateErrors(
                  set({}, 'bankAccount.routingNumber', error.message)
                )
              )
            } else {
              dispatch(updateErrors(updateErrors({ general: error.message })))
            }
          } else {
            createCashFund(assign({}, data, token), true)
              .then(() => {
                onSuccess()
              })
              .catch((errors) => {
                dispatch(updateErrors(errors))
              })
              .then(() => {
                dispatch({ type: SAVE_FINISH })
              })
          }
        })
    } else {
      createCashFund(data, false)
        .then(() => {
          onSuccess()
        })
        .catch((errors) => {
          dispatch(updateErrors(errors))
        })
        .then(() => {
          dispatch({ type: SAVE_FINISH })
        })
    }
  }
}

export const SAVE_FINISH = 'SAVE_FINISH'
export const SAVE_START = 'SAVE_START'

export const SELECT_FUND = 'SELECT_FUND'
export const selectFund = (fund) => {
  return {
    type: SELECT_FUND,
    fund,
  }
}

export const SET_DEFAULTS = 'SET_DEFAULTS'
export const setDefaults = (defaults) => {
  return {
    type: SET_DEFAULTS,
    defaults,
  }
}

export const SHOW_CASH_FUND_WIZARD = 'SHOW_CASH_FUND_WIZARD'
export const showWizard = (ui) => {
  return {
    type: SHOW_CASH_FUND_WIZARD,
    ui,
  }
}

export const TOGGLE_COLLAPSE = 'TOGGLE_COLLAPSE'
export const toggleCollapse = (uiToggleState) => {
  return {
    type: TOGGLE_COLLAPSE,
    uiToggleState,
  }
}

export const TRANSFER = 'TRANSFER'
export const transfer = () => {
  return fetch(apiV3TransferRequestsPath, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((resp) => {
      infoMessage(
        'Your transfer request has been received! It may take a few business days for the money to be available in your account. '
      )
      // reload the page so they see the transfer has been requested
      // TODO: hook this up to a dispatch action
      window.location.reload()
    })
    .catch((errors) => {
      errorMessage('Unable to submit transfer request.')
    })
}

export const UPDATE_ERRORS = 'UPDATE_ERRORS'
export const updateErrors = (errors) => {
  return {
    type: UPDATE_ERRORS,
    errors,
  }
}

export const UPDATE_FIELD = 'UPDATE_FIELD'
export const updateField = (attr, value) => {
  return {
    type: UPDATE_FIELD,
    attr,
    value,
  }
}
